<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/professions`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h3>Редактирование специальности</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="code" class="form-label col-md-4">
            Код специальности
          </label>
          <div class="col-md-8">
            <input class="form-control" id="code" type="text"
                   :disabled="true"
                   v-model="profession.code">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="name" class="form-label col-md-4">
            Наименование специальности
          </label>
          <div class="col-md-8">
            <input class="form-control" id="name" type="text" v-model="profession.nameRu">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-10">
        <div class="el-input-group">
          <label for="name" class="form-label col-md-4">
            Направление специальности
          </label>
          <div class="col-md-8">
            <select v-model="profession.direction.id" id="directionId"
                    class="form-select">
              <option v-for="item in professionDirections" :key="item.id"
                      :value="item.id">
                {{ item.code }} {{ item.nameRu }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="page-footer justify-content-end"  v-if="isAdmin()">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import professionService from "@/services/professionService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import professionDirectionService from "@/services/professionDirectionService";

export default {
  components: {
    VueLoading
  },
  computed: {
    professionUuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      professionDirections: [],
      profession: {
        id: {
          code: null
        },
        nameRu: null,
        sum: null,
        direction: {
          id: null
        }
      }
    };
  },
  methods: {
    init() {
      this.findById(this.professionUuid);
      this.loadData();
    },

    async loadData() {
      this.isLoading = true;
      this.professionDirections = await professionDirectionService.getAllDirectionList();
      this.isLoading = false;
    },

    async findById(uuid) {
      this.isLoading = true;
      this.profession = await professionService.findByUuid(uuid);
      if (!this.profession.direction) {
        this.profession.direction = {id: null};
      }
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;
        this.profession = await professionService.save(this.profession);
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
